import {SListTabs} from "shj-components";
import {getAuth} from "shj-utils";
import ChannelCallBack from "./channelCallBack";
import Seating from "./seating";
import LineAllocation from "@/pages/callTool/outboundCallAccess/lineAllocation";

const OutboundCallAccess = () => {
  const items = [
    {
      key: 'channelCallBack',
      label: '通道回调配置',
      children: <ChannelCallBack/>,
      auth: 'channelCallBackOutBoundTab',
    },
    {
      key: 'seating',
      label: '坐席配置',
      children: <Seating/>,
      auth: 'seatingOutBoundTab',
    },
    {
      key: 'lineAllocation',
      label: '线路分配',
      children: <LineAllocation/>,
      auth: 'lineAllocationOutBoundTab',
    },
  ]

  return <SListTabs auth={getAuth()}
                    hideExtra={true}
                    items={items}
  />
}

export default OutboundCallAccess